export default __webpack_public_path__ + "static/game-digi-38f294fbd1cebdfb13ba7d02b31cc1b8.webp";